import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthData } from '../models/auth-model';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { MatDialog } from '@angular/material';
import { UtilsService } from './utils.service';
import { Usuario } from 'app/main/autenticacion/models/usuario';

const BACKEND_URL = environment.apiUrl + '/';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated = false;
  private token: string;
  private tokenTimer: any;
  private userId: string;
  private userName: string;
  private authStatusListener = new Subject<boolean>(); 
  private usuario: Usuario;
  
  private comision: string;

  constructor(private http: HttpClient, private router: Router,
    private _fuseSplashScreenService: FuseSplashScreenService,
    private _dialogService: MatDialog,
    private utilService: UtilsService) { }  
  /**
   * Ontenemos el nombre del usuario.
   */
  getUserName(): string {
    return this.userName;
  }

  /**
   * Obtenemos el token.
   */
  getToken(): string {
    return this.token;
  }


  /**
   * Ontenemos el nombre del usuario.
   */
  obtenerUsuario(): Usuario {
    return this.usuario;
  }

  
  

  /**
   * Obtenemos true si el usuario esta autentiado false si no esta.
   */
  getIsAuth(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Obtenemos el id del usuario.
   */
  getUserId(): string {
    return this.userId;
  }

  /**
   * Retornamos un observable el cual proveera de la informacion del usuario en determinado momento.
   */
  getAuthStatusListener(): Observable<any> {
    return this.authStatusListener.asObservable();
  }


  /**
   * Crea el usuario para guardarlo en la base
   * @param email del usuario
   * @param name del usuario
   * @param password del usuario
   */
  createUser(email: string, name: string, password: string): void {
    const authData: AuthData = { email: email, pass: password };
    this.http.post(BACKEND_URL + 'signup', authData).subscribe(
      (response) => {
        this.router.navigate(['/']);
      },
      error => {
        this.authStatusListener.next(false);
      }
    );
  }

  /**
   * Intentamos logearnos.
   * @param email del usuario
   * @param password del usuario
   */
  login(email: string, password: string): void {
    this._fuseSplashScreenService.show();
    const authData: AuthData = { email: email, pass: password };
    this.http
      .post<any>(
        BACKEND_URL + 'auth/login',
        authData
      )
      .subscribe(
        response => {
          const token = response.token;
          this.token = token;
          if (token) {
            this._fuseSplashScreenService.show();
            const expiresInDuration = response.expiresIn;
            this.setAuthTimer(expiresInDuration);
            this.isAuthenticated = true;
            this.userId = response.result[0].id;
            this.authStatusListener.next(true);
            const now = new Date();
            this.usuario = response.result[0];
            this.userName = response.result[0].usua; 
            const expirationDate = new Date(
              now.getTime() + expiresInDuration * 1000
            );
            this.saveAuthData(token, expirationDate, this.userId, response.userName, this.comision);
            this.router.navigate(['/']);
            this._fuseSplashScreenService.hide();
          }
        },
        error => {
          this._fuseSplashScreenService.hide();
          this.authStatusListener.next(false);
        }
      );
  }

  autoAuthUser(): void {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.userId = authInformation.userId;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListener.next(true);
    }
  }

  /**
   * Aqui mandamos falso y avisamos que el usuario no esta autenticado
   */
  logout(): void {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    this.userId = null;
    clearTimeout(this.tokenTimer);
    this.clearAuthData();
    this.router.navigate(['/auth/login']);
  }

  /**
   * Crea una funcion de timer para que cuando pase el tiempo del logeo el usuario salga de la app
   * @param duration la duracion que se desa que el usuario permanezca logeado
   */
  private setAuthTimer(duration: number): void {
    this.tokenTimer = setTimeout(() => {

      // this._dialogService.open(ErrorComponent, { data: { message: 'Your session has expired, please login again!', title: 'Auto logout' } });
      // alert('La sesion ha terminado, inicia sesion de nuevo.');
      this.utilService.openSnackBarError('La sesion ha terminado, inicia sesion de nuevo.', 'close');
      this.logout();
    }, duration * 1000);
  }


  /**
   * Guarda la informacion del usuario en el local storage.
   * @param token token que se guardara en el localstorage
   * @param expirationDate la fecha de expiracion que tendra el token.
   * @param userId el id del usuario generado.
   * @param userName el nombre del usuario.
   */
  private saveAuthData(token: string, expirationDate: Date, userId: string, userName: string, comision: string): void {
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expirationDate.toISOString());
    localStorage.setItem('userId', userId);
    localStorage.setItem('userName', userName);
    localStorage.setItem('comision', comision);
  }

  /**
   * Limpiamos la informacion del usuario.
   */
  private clearAuthData(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('comision');
  }


  /**
   * Cuando queremos obtener la informacion de autenticacion del usuario ejecutamos este metodo.
   */
  private getAuthData(): null | { token: string, expirationDate: Date, userId: string } {
    const token = localStorage.getItem('token');
    const expirationDate = localStorage.getItem('expiration');
    const userId = localStorage.getItem('userId');
    if (!token || !expirationDate) {
      return;
    }
    return {
      token: token,
      expirationDate: new Date(expirationDate),
      userId: userId
    };
  }
}
